// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 文章管理管理
import Goods from '@/views/goods/Goods';
// 新增文章
import addGoods from '@/views/goods/addGoods';
// 编辑文章
import editGoods from '@/views/goods/editGoods';
// 留言板
import messageBoard from '@/views/messageboard/index';

// 太平洋保险文章管理
import articleList from '@/views/CPIC/articleList';
// 新增太平洋保险文章管理
import addArticleList from '@/views/CPIC/addArticle';
// 编辑太平洋保险文章管理
import editArticleList from '@/views/CPIC/editArticle';

// 留言板
import banners from '@/views/banner/index';
// 公司信息
import companyMessage from '@/views/companyMessage/companyMessage';


// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/goods/Goods',
            name: '首页文章',
            component: Goods,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/goods/addGoods',
            name: '添加文章',
            component: addGoods,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/goods/editGoods',
            name: '编辑文章',
            component: editGoods,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/messageboard',
            name: '留言板',
            component: messageBoard,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/banners',
            name: '轮播图管理',
            component: banners,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        },

        {
            path: '/CPIC/articleList',
            name: '太平洋保险',
            component: articleList,
            meta: {
                requireAuth: true
            }
        },

        {
            path: '/CPIC/addArticleList',
            name: '新增太保文章',
            component: addArticleList,
            meta: {
                requireAuth: true
            }
        },

        {
            path: '/CPIC/editArticleList',
            name: '编辑太保文章',
            component: editArticleList,
            meta: {
                requireAuth: true
            }
        },

            // {
            //     path: '/companyMessage',
            //     name: '公司信息',
            //     component: companyMessage,
            //     meta: {
            //         requireAuth: true
            //     }
            // }
        ]
    },
        // {
        //     path: '/messageboard',
        //     name: '留言板管理',
        //     component: index,
        //     iconCls: 'el-icon-tickets',
        //     children: [{
        //         path: '/messageboard',
        //         name: '首页文章',
        //         component: Goods,
        //         meta: {
        //             requireAuth: true
        //         }
        //     },]
        // },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js